// extracted by mini-css-extract-plugin
export default {"mainMenu":"components-MainMenu-themes-PP-styles__mainMenu--ZR6bT"};